import {useFetchEffect} from 'hooks/useFetchEffect'
import {useHistory, useParams} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {Form} from 'procedures/changeDependents/remove/Form'
import api from 'api'
import {actionCreators} from 'actions'
import {get, isEmpty} from 'lodash'
import {asyncError} from 'store/actions/asyncError'

const makeInitialValues = (procedureStatus, employee_dependents) => {
  if (isEmpty(procedureStatus.procedure_remove_dependents_data)) return {}

  const dependents = employee_dependents.flatMap((dependent) => {
    const remove_data = procedureStatus.procedure_remove_dependents_data.find(
      (remove_data) => dependent.id === remove_data.employee_dependent_id
    )
    return remove_data ? {...dependent, is_report_target: remove_data.is_report_target} : []
  })

  return {
    date_on: procedureStatus.date_on,
    dependents: dependents,
  }
}

export const Update = () => {
  const history = useHistory()
  const {id} = useParams()
  const dispatch = useDispatch()
  const procedureStatus = useSelector((state) => state.procedureStatuses.current.data)
  const token = useSelector((state) => state.auth.token)

  const employee = procedureStatus.employee || {}
  const healthInsuranceType = get(employee, 'office.health_insurance_type')

  const loadProcedureStatus = () => {
    dispatch(
      actionCreators.procedureStatuses.current.fetchData(
        api
          .createWithAuth(token)
          .procedureStatuses.get(
            id,
            ['employee', 'employee_dependents', 'procedure_remove_dependents_data', 'office'],
            {
              employee_dependent_removed: [0, 1],
            }
          )
      )
    )
  }

  const update = async ({dependents, date_on: dateOn}) => {
    const authedApi = api.createWithAuth(token)
    try {
      await authedApi.procedureStatuses.update(procedureStatus.id, {date_on: dateOn})
      for (let dependent of dependents) {
        await authedApi.employees.dependents.update(procedureStatus.employee_id, dependent)
        const removeData = procedureStatus.procedure_remove_dependents_data.find(
          (removeData) => removeData.employee_dependent_id === dependent.id
        )
        await authedApi.procedureStatuses.removeDependentsData.update(
          id,
          removeData.id,
          dependent.id,
          dependent.is_report_target
        )
      }
      history.push(`/procedure_statuses/${procedureStatus.id}`)
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  useFetchEffect(() => {
    loadProcedureStatus()
    return () => dispatch(actionCreators.procedureStatuses.current.destroy())
  }, [])

  return (
    <Form
      onSubmit={update}
      initialValues={makeInitialValues(procedureStatus, employee.employee_dependents)}
      submitText="保存"
      employee={employee}
      healthInsuranceType={healthInsuranceType}
    />
  )
}
